import { render, staticRenderFns } from "./PurchaseTemp.vue?vue&type=template&id=953c078a&"
import script from "./PurchaseTemp.vue?vue&type=script&lang=js&"
export * from "./PurchaseTemp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports